import { Lock } from '@styled-icons/remix-fill/Lock';
import FormButton from 'components/Button';

import * as S from './style';
import StripeLogo from 'assets/svg/stripe-logo.svg';

export type PlaidButtonType = {
  children: string | JSX.Element;
  icon?: JSX.Element;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
};

const PlaidButton = ({
  children,
  icon,
  onClick,
  disabled,
  type = 'button',
}: PlaidButtonType) => {
  return (
    <S.Wrapper>
      <S.ButtonWrapper>
        <FormButton
          fullWidth
          disabled={disabled}
          icon={icon ?? undefined}
          onClick={onClick}
          type={type}
        >
          {children}
        </FormButton>
      </S.ButtonWrapper>
      <S.Details>
        <S.Stripe>
          <Lock size={14} />
          Secure by
          <img src={StripeLogo} alt="Stripe logo" />
        </S.Stripe>
      </S.Details>
    </S.Wrapper>
  );
};

export default PlaidButton;
